export const WHITE = '#ffffff';
export const PEACH = '#ffdbcf';
export const PLUM = '#84565e';

export const SOY = '#30323b';
export const MEDIUM_SOY = '#696970';
export const LIGHT_SOY = '#BABCC1';

export const MEDIUM_TOFU = '#E5E5E6';
export const BOK_CHOY = '#5BCA81';
export const TOMATO = '#F15541';

export const ERROR = '#C7254E';
